<template>
  <router-view />
</template>

<script>
export default {
  name: "e-sports"
};
</script>